import React from "react"
import PropTypes from "prop-types"
import StandardButton from '../app_components/StandardButton'
import StandardModal from '../app_components/StandardModal'
import Icon from '../app_components/Icon'
import OnboardingToast, { bindOnboardingToastHandlers } from '../onboarding_sections/OnboardingToast'
import ProfileLanguageFlag from '../app_components/ProfileLanguageFlag'
import { semantic, primitives } from '@lexody/design-tokens'
import { getLanguageLevelLabel } from '../connect_sections/connectMemberHelpers'
import Search from '../form_sections/Search'

class LanguageSettings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      languages: [],
      openLanguageChoices: false,
      languageChoices: [],
      newLanguage: [],
      languageLevelOpen: false,
      levels: [5, 4, 3, 2, 1],
      needsLearningLanguage: false,
      needsNativeLanguage: false,
      toastMessage: null,
      searchLanguageValue: ""
    }

    if (props.nextButton) {
      bindOnboardingToastHandlers(this)
    }

    this.renderNativeLanguages = this.renderNativeLanguages.bind(this)
    this.renderLearningLanguages = this.renderLearningLanguages.bind(this)
    this.renderLanguageRow = this.renderLanguageRow.bind(this)
    this.languageChoices = this.languageChoices.bind(this)
    this.selectALanguage = this.selectALanguage.bind(this)
    this.selectNewLanguage = this.selectNewLanguage.bind(this)
    this.closeLanguageChoices = this.closeLanguageChoices.bind(this)
    this.nativeLevelOptions = this.nativeLevelOptions.bind(this)
    this.learningLevelOptions = this.learningLevelOptions.bind(this)
    this.selectLevel = this.selectLevel.bind(this)
    this.editLanguage = this.editLanguage.bind(this)
    this.updateLanguagesUser = this.updateLanguagesUser.bind(this)
    this.createLanguagesUser = this.createLanguagesUser.bind(this)
    this.updateUserLanguages = this.updateUserLanguages.bind(this)
    this.checkLanguages = this.checkLanguages.bind(this)
    this.nextButton = this.nextButton.bind(this)
    this.renderLanguageSuggestions = this.renderLanguageSuggestions.bind(this)
    this.languageChoice = this.languageChoice.bind(this)
    this.languageIsIncluded = this.languageIsIncluded.bind(this)
    this.getSignupValidationMessage = this.getSignupValidationMessage.bind(this)
  }

  componentWillUnmount() {
    if (this.props.nextButton) {
      this.clearOnboardingToast()
    }
  }

  getSignupValidationMessage() {
    if (this.state.needsNativeLanguage && this.state.needsLearningLanguage) {
      return 'Please add your native language and a language you are learning.'
    }
    if (this.state.needsNativeLanguage) {
      return 'Please add your native language.'
    }
    if (this.state.needsLearningLanguage) {
      return 'Add a language you are learning.'
    }
    return null
  }

  componentWillMount() {
    $.ajax({
      url: `../ajaxGetLanguages`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          languages: JSON.parse(data.data.languages),
          languageChoices: data.data.allLanguages
        }, () => this.checkLanguages())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    this.checkLanguages()
  }

  languageIsIncluded(language) {
    return this.state.languages.find(lang => lang.language_id === language.id) != undefined
  }

  renderLanguageSuggestions() {
    if (this.state.searchLanguageValue === "") {
      return this.state.languageChoices
        .filter(language => language.primary === true && !this.languageIsIncluded(language))
        .map((language, i) => this.languageChoice(language, i))
    }

    const searchLanguageValue = this.state.searchLanguageValue.toLowerCase()
    const languages = this.state.languageChoices.filter(language => {
      return (language.language.toLowerCase().includes(searchLanguageValue) ||
        (language.native != null && language.native.toLowerCase().includes(searchLanguageValue)))
    })
    return languages.slice(0, 10).map((language, i) => this.languageChoice(language, i))
  }

  renderLanguageRow(language, index) {
    const levelLabel = getLanguageLevelLabel(language.level)
    const nativeName = language.language.native

    return (
      <div className="my-languages__row" key={index}>
        <div className="profile-languages__row">
          <ProfileLanguageFlag flagHtml={language.language.flag_html} />
          <button
            type="button"
            className={`profile-languages__level language_level language_level${language.level} my-languages__levelBtn`}
            onClick={() => this.editLanguage(language.language)}
          >
            <span className="profile-languages__levelText">
              {levelLabel} {nativeName}
            </span>
          </button>
        </div>
        <button
          type="button"
          className="my-languages__removeBtn"
          onClick={() => this.deleteLanguagesUser(language.id)}
          aria-label={`Remove ${nativeName}`}
        >
          <Icon
            name="times"
            size={16}
            color={semantic.error.surface.default}
          />
        </button>
      </div>
    )
  }

  renderNativeLanguages() {
    return this.state.languages
      .filter(language => language.level === 5)
      .map((language, index) => this.renderLanguageRow(language, index))
  }

  renderLearningLanguages() {
    return this.state.languages
      .filter(language => language.level < 5)
      .map((language, index) => this.renderLanguageRow(language, index))
  }

  checkLanguages() {
    this.setState({
      needsNativeLanguage: this.state.languages.filter(language => language.level === 5).length < 1,
      needsLearningLanguage: this.state.languages.filter(language => language.level < 5).length < 1
    })
  }

  selectNewLanguage(language) {
    this.setState({
      newLanguage: language,
      languageLevelOpen: true,
      openLanguageChoices: false,
    })
  }

  languageChoice(language, i) {
    const languageIsIncluded = this.languageIsIncluded(language)
    return (
      <button
        type="button"
        key={i}
        className={`my-languages-page__chip${languageIsIncluded ? ' my-languages-page__chip--selected' : ''}`}
        onClick={() => this.selectNewLanguage(language)}
      >
        {language.native}
        <Icon
          name={languageIsIncluded ? 'check' : 'plus'}
          size={12}
          color={languageIsIncluded ? '#fff' : semantic.primary.surface.default}
        />
      </button>
    )
  }

  selectALanguage() {
    return this.state.languageChoices.map((language, i) => {
      return this.languageChoice(language, i)
    })
  }

  editLanguage(language) {
    this.setState({
      newLanguage: language,
      languageLevelOpen: true
    })
  }

  closeLanguageChoices() {
    this.setState({
      openLanguageChoices: false,
      newLanguage: {},
      languageLevelOpen: false
    })
  }

  languageChoices() {
    return (
      <StandardModal onClose={() => this.closeLanguageChoices()} size="wide">
        <div className="selectItemContainer">
          {this.selectALanguage()}
        </div>
      </StandardModal>
    )
  }

  createLanguagesUser(language_id, level) {
    const data = {
      level: level,
      language_id: language_id
    }
    this.setState({
      languageLevelOpen: false
    })

    $.ajax({
      url: `../ajaxCreateLanguagesUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateLanguagesUser(languages_user_id, level) {
    this.setState({
      languageLevelOpen: false
    })
    $.ajax({
      url: `../ajaxUpdateLanguagesUser`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        level: level,
        id: languages_user_id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateUserLanguages(languageArray) {
    this.setState({
      languages: languageArray,
    })
    this.checkLanguages()
  }

  deleteLanguagesUser(languages_user_id) {
    $.ajax({
      url: `../ajaxDeleteLanguagesUser`,
      dataType: 'JSON',
      type: 'DELETE',
      data: {
        id: languages_user_id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.updateUserLanguages(JSON.parse(data.data.languages))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  selectLevel(level) {
    const newLanguage = this.state.newLanguage
    const currentLanguages = this.state.languages.filter(function(language) {
      return language.language_id == newLanguage.id
    })
    if (currentLanguages.length > 0) {
      this.updateLanguagesUser(currentLanguages[0].id, level)
    } else {
      this.createLanguagesUser(newLanguage.id, level)
    }
  }

  renderLevelOption(level) {
    const label = getLanguageLevelLabel(level)
    const langName = this.state.newLanguage.language || this.state.newLanguage.native

    return (
      <button
        type="button"
        className={`my-languages-levelPicker__option my-languages-levelPicker__option--level${level}`}
        onClick={() => this.selectLevel(level)}
        key={level}
      >
        {label} {langName}
      </button>
    )
  }

  nativeLevelOptions() {
    return this.state.levels
      .filter(level => level === 5)
      .map(level => this.renderLevelOption(level))
  }

  learningLevelOptions() {
    return this.state.levels
      .filter(level => level < 5)
      .map(level => this.renderLevelOption(level))
  }

  languageLevelChoices() {
    const langName = this.state.newLanguage.language || this.state.newLanguage.native

    return (
      <StandardModal onClose={() => this.closeLanguageChoices()}>
        <p className="my-languages-levelPicker__heading">
          What is your speaking level of <strong>{langName}</strong>?
        </p>
        <div className="my-languages-levelPicker">
          <p className="my-languages-levelPicker__sectionLabel">Fluent</p>
          {this.nativeLevelOptions()}
          <p className="my-languages-levelPicker__sectionLabel">Learning</p>
          {this.learningLevelOptions()}
        </div>
      </StandardModal>
    )
  }

  nextButton() {
    return (
      <div className="onboarding-page__footer">
        <OnboardingToast message={this.state.toastMessage} />
        <StandardButton
          text="Continue"
          variant="primary"
          fullWidth
          size="large"
          onClick={() => {
            const message = this.getSignupValidationMessage()
            if (message) {
              this.showOnboardingToast(message)
            } else {
              window.location.assign('/upload_picture')
            }
          }}
        />
      </div>
    )
  }

  openLanguagePicker() {
    this.setState({ openLanguageChoices: true })
  }

  renderLanguageSection(title, iconName, children, needsLanguage, alertText, isNative) {
    const isSignup = Boolean(this.props.nextButton)
    const iconColor = isNative ? primitives.blue['500'] : primitives.violet['600']
    const iconCircleClass = isNative
      ? 'profile-languages__iconCircle--native'
      : 'profile-languages__iconCircle--learning'

    return (
      <section className={`profile-languages my-languages-page__card${isSignup ? ' my-languages-page__card--onboarding' : ''}`}>
        <header className="profile-languages__header">
          <div className="profile-languages__titleRow my-languages-page__groupTitle">
            <span className={`profile-languages__iconCircle ${iconCircleClass}`} aria-hidden="true">
              <Icon name={iconName} size={18} color={iconColor} solid />
            </span>
            <h2 className={`profile-languages__title${isSignup ? ' profile-languages__title--onboarding' : ''}`}>{title}</h2>
          </div>
        </header>
        {children}
        {needsLanguage && (
          <button
            type="button"
            className="my-languages-page__alert"
            onClick={() => this.openLanguagePicker()}
          >
            <p className="my-languages-page__alertText">{alertText}</p>
          </button>
        )}
      </section>
    )
  }

  render() {
    return (
      <div className="my-languages-page">
        {this.state.openLanguageChoices && this.languageChoices()}
        {this.state.languageLevelOpen && this.languageLevelChoices()}

        <header className="my-languages-page__header">
          <div className="my-languages-page__titleRow">
            <span className="my-languages-page__iconCircle my-languages-page__iconCircle--page" aria-hidden="true">
              <Icon name="english-to-chinese" size={22} color={primitives.blue['500']} solid />
            </span>
            <h1 className={`my-languages-page__title${this.props.nextButton ? ' my-languages-page__title--onboarding' : ''}`}>My Languages</h1>
          </div>
          <p className="my-languages-page__subtitle">
            Add languages you speak and ones you want to practice
          </p>
        </header>

        <section className="my-languages-page__searchCard">
          <Search
            value={this.state.searchLanguageValue}
            placeholder="Search languages"
            onChange={(value) => this.setState({ searchLanguageValue: value })}
          />
          <div className="my-languages-page__suggestions">
            {this.renderLanguageSuggestions()}
          </div>
          <button
            type="button"
            className="my-languages-page__seeAll"
            onClick={() => this.openLanguagePicker()}
          >
            see all languages
          </button>
        </section>

        <div className="my-languages-page__columns">
          {this.renderLanguageSection(
            'I can offer…',
            'comment',
            this.renderNativeLanguages(),
            this.state.needsNativeLanguage,
            'Add your native language',
            true
          )}
          {this.renderLanguageSection(
            'I want to practice…',
            'comments',
            this.renderLearningLanguages(),
            this.state.needsLearningLanguage,
            'Add a language you are learning',
            false
          )}
        </div>

        {this.props.nextButton && this.nextButton()}
      </div>
    )
  }
}

export default LanguageSettings;
